export const environment = {
  appName: 'SMP',
  appCode: 'SHAGO',
  editType: 'modal',
  production: true,
  backendUrl: 'http://shagoglobal.com',
  useProductUnit: false,
  useProductStock: false,
  useGeneralBoxDelivery: false,
};
